import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { Loader2, AlertCircle } from "lucide-react";
import { portalDestinationForVerification } from "@/lib/clientSetupFlow";

export default function ClientVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { verifyMagicLink } = useAuth();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // Avoid double-fire under React StrictMode
    ran.current = true;
    const token = params.get("token");
    if (!token) { setError("Missing token"); return; }
    (async () => {
      try {
        const data = await verifyMagicLink(token);
        if (portalDestinationForVerification(data) === "setup") {
          navigate(`/portal/setup?token=${encodeURIComponent(data.setup_token)}`, {
            state: { email: data.email },
            replace: true,
          });
        } else {
          navigate("/portal");
        }
      } catch (e) { setError(formatApiError(e)); }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--fb-bg)" }}>
      <div className="max-w-md w-full fb-card p-10 text-center">
        {!error ? (
          <>
            <Loader2 className="w-8 h-8 mx-auto mb-4 animate-spin" style={{ color: "var(--fb-primary)" }} />
            <p style={{ color: "var(--fb-text-muted)" }}>Signing you in…</p>
          </>
        ) : (
          <>
            <AlertCircle className="w-10 h-10 mx-auto mb-4" style={{ color: "var(--fb-error)" }} />
            <h2 className="text-xl font-semibold mb-2" style={{ fontFamily: "Outfit" }}>Sign-in failed</h2>
            <p className="text-sm mb-4" style={{ color: "var(--fb-text-muted)" }}>{error}</p>
            <button onClick={() => navigate("/portal/login")} className="fb-btn-primary px-5 py-2.5 rounded-lg font-semibold">
              Request a new link
            </button>
          </>
        )}
      </div>
    </div>
  );
}
